"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _bootstrapModal = require("../bootstrap-modal");
var _filter = _interopRequireDefault(require("lodash/filter"));
var _groupBy = _interopRequireDefault(require("lodash/groupBy"));
var _map = _interopRequireDefault(require("lodash/map"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var LocationBody = function LocationBody(_ref) {
  var metros = _ref.metros,
    clickMetro = _ref.clickMetro,
    toggleModal = _ref.toggleModal;
  var activeMetros = (0, _filter.default)(metros, {
    active: true
  });
  var continents = (0, _groupBy.default)(activeMetros, function (metro) {
    if ('US' === metro.country) {
      return 'United States';
    }
    if ('CA' === metro.country) {
      return 'Canada';
    }
    return 'Europe';
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container-fluid",
    style: {
      paddingBottom: '24px'
    }
  }, (0, _map.default)(continents, function (continent, key) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginTop: '24px'
      },
      key: key,
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/_react.default.createElement("h5", null, key), /*#__PURE__*/_react.default.createElement("hr", null)), (0, _map.default)((0, _sortBy.default)(continent, 'name'), function (metro, i) {
      var name = metro.name;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "".concat(continent, "-").concat(i),
        className: "col-xs-6 col-sm-4"
      }, /*#__PURE__*/_react.default.createElement("button", {
        style: {
          paddingLeft: 0
        },
        className: "btn btn-link remove-click-styling",
        onClick: function onClick(e) {
          clickMetro(e, toggleModal);
        },
        "data-value": metro.nickname
      }, name));
    }));
  }));
};
var LocationModal = exports.LocationModal = /*#__PURE__*/function (_React$Component) {
  _inherits(LocationModal, _React$Component);
  function LocationModal() {
    _classCallCheck(this, LocationModal);
    return _callSuper(this, LocationModal, arguments);
  }
  _createClass(LocationModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        showModal = _this$props.showModal,
        toggleModal = _this$props.toggleModal,
        clickMetro = _this$props.clickMetro,
        metros = _this$props.metros;
      return /*#__PURE__*/_react.default.createElement(_bootstrapModal.BootstrapModal, {
        showModal: showModal,
        modalSize: "md-size",
        modalClass: "activity-modal",
        onClose: toggleModal,
        header: /*#__PURE__*/_react.default.createElement("h3", null, "Peerspace Locations"),
        body: /*#__PURE__*/_react.default.createElement(LocationBody, {
          metros: metros,
          clickMetro: clickMetro,
          toggleModal: toggleModal
        })
      });
    }
  }]);
  return LocationModal;
}(_react.default.Component);
LocationModal.propTypes = {
  metros: _propTypes.default.array.isRequired,
  showModal: _propTypes.default.bool,
  toggleModal: _propTypes.default.func,
  clickMetro: _propTypes.default.func
};
LocationBody.propTypes = {
  metros: _propTypes.default.array,
  clickMetro: _propTypes.default.func,
  toggleModal: _propTypes.default.func
};